var React = require('react');

function ArrowBlackInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#"},React.createElement("path",{"d":"M41.5 4.5H.165M3.576 8 0 4.5 3.576 1"})));
}

ArrowBlackInline.defaultProps = {"width":"42","height":"9"};

module.exports = ArrowBlackInline;

ArrowBlackInline.default = ArrowBlackInline;
